import React from 'react';
import {
  Truck, PackageCheck, RotateCcw, Banknote, ShieldCheck, BadgeCheck, CreditCard, Wallet, Gift, Percent, Tag,
  Heart, HandHeart, Smile, ThumbsUp, Star, Award, Crown, Gem, Sparkles, Leaf, Flower2, Feather, Shirt, Ruler,
  Scissors, Clock, Timer, Zap, Headphones, MessageCircle, Phone, MapPin, Store, Globe, Lock, Recycle
} from 'lucide-react';

// The three original line drawings (kept so the strip looks the same by default)
const ReturnsBox = props => (
  <svg viewBox="0 0 34 34" fill="none" {...props}>
    <path d="M17 3L5 9.5V22.5L17 29L29 22.5V9.5L17 3Z" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M17 15.5L5 9.5M17 15.5L29 9.5M17 15.5V29" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M11 25.5L8 23.5L11 21.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M8 23.5H15" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const CashHand = props => (
  <svg viewBox="0 0 34 34" fill="none" {...props}>
    <rect x="6" y="7" width="22" height="13" rx="2" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="17" cy="13.5" r="3.5" stroke="currentColor" strokeWidth="1.4" />
    <path d="M15.5 12H18.5M15.5 13.5H18.5M15.5 12V15M17 13.5L18.5 15" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
    <path d="M5 23C8.5 22 12 21 16 22.5L21 24.5C23.5 25.5 26 24 26.5 22" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    <path d="M12 24.5L7 26.5C5 27.5 3 26 3 24V23" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);

const DeliveryTruck = props => (
  <svg viewBox="0 0 34 34" fill="none" {...props}>
    <path d="M3 10H19V24H3V10Z" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M19 13H25L28 17V24H19V13Z" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="9" cy="24" r="3" stroke="currentColor" strokeWidth="1.8" fill="#FFF" />
    <circle cx="23" cy="24" r="3" stroke="currentColor" strokeWidth="1.8" fill="#FFF" />
    <path d="M1 13H0M0 16H2M1 19H0" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);

// key → icon (same keys as the admin and the server)
export const TRUST_ICONS = {
  'returns-box': ReturnsBox,
  'cash-hand': CashHand,
  'delivery-truck': DeliveryTruck,
  truck: Truck,
  'package-check': PackageCheck,
  'rotate-ccw': RotateCcw,
  banknote: Banknote,
  'shield-check': ShieldCheck,
  'badge-check': BadgeCheck,
  'credit-card': CreditCard,
  wallet: Wallet,
  gift: Gift,
  percent: Percent,
  tag: Tag,
  heart: Heart,
  'hand-heart': HandHeart,
  smile: Smile,
  'thumbs-up': ThumbsUp,
  star: Star,
  award: Award,
  crown: Crown,
  gem: Gem,
  sparkles: Sparkles,
  leaf: Leaf,
  flower: Flower2,
  feather: Feather,
  shirt: Shirt,
  ruler: Ruler,
  scissors: Scissors,
  clock: Clock,
  timer: Timer,
  zap: Zap,
  headphones: Headphones,
  'message-circle': MessageCircle,
  phone: Phone,
  'map-pin': MapPin,
  store: Store,
  globe: Globe,
  lock: Lock,
  recycle: Recycle
};
